module.exports = __webpack_public_path__ + "static/media/login.e435a093.jpg";